<template>
    <div class="home">
        <v-container>
            <v-row>
                <v-col class="mb-6 pb-0">
                    <p class="greetings text-center mb-0">שלום, {{userName}}</p>
                </v-col>
            </v-row>

            <v-tabs v-model="activeTab"
                    grow
                    centered
                    color="primary"
                    class="mb-4">
                <v-tab v-for="t in tabs" :key="t.bucket">{{t.label}}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <v-tab-item v-for="t in tabs" :key="t.bucket">
                    <v-row>
                        <v-col cols="12">
                            <template v-if="bucketLoading[t.bucket]">
                                <div class="loaderSection" v-for="index in 4" :key="t.bucket + '-skeleton-' + index">
                                    <v-skeleton-loader type="list-item-avatar@4"></v-skeleton-loader>
                                    <v-skeleton-loader type="article"></v-skeleton-loader>
                                </div>
                            </template>
                            <template v-else>
                                <v-mission-card v-for="mission in visibleMissions(t.bucket)"
                                                :mission="mission"
                                                :key="mission.missionID"></v-mission-card>
                                <p class="text-center" v-if="bucketLoaded[t.bucket] && !visibleMissions(t.bucket).length">
                                    {{emptyMessage(t.bucket)}}
                                </p>
                            </template>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import vMissionCard from '../components/vMissionCard'
    import moment from 'moment'

    const TABS = [
        { bucket: 'today',  label: 'היום' },
        { bucket: 'future', label: 'עתידי' },
        { bucket: 'closed', label: 'בוצע' },
    ];

    export default {
        name: 'vHome',
        data() {
            return {
                now: '',
                activeTab: 0,
                tabs: TABS,
            }
        },
        components: {
            vMissionCard,
        },
        mounted() {
            this.getTime();
            this.loadActiveBucket();
        },
        watch: {
            activeTab() {
                this.loadActiveBucket();
            }
        },
        computed: {
            ...mapState(['userName', 'missionsByBucket', 'bucketLoading', 'bucketLoaded']),
        },
        methods: {
            ...mapActions(['GET_TIME', 'GET_TASKS_BY_BUCKET']),
            isTokenValid(mission) {
                return mission.missionStatus !== 'בוצע' || moment(this.now).isBefore(moment(mission.missionCoinValidDate));
            },
            visibleMissions(bucket) {
                return (this.missionsByBucket[bucket] || []).filter(mission => this.isTokenValid(mission));
            },
            getTime() {
                return this.GET_TIME().then((response) => {
                    this.now = response;
                }).catch(error => {
                    console.error('Failed to get time:', error);
                    this.now = moment().toISOString();
                });
            },
            loadActiveBucket() {
                const bucket = this.tabs[this.activeTab].bucket;
                if (this.bucketLoaded[bucket] || this.bucketLoading[bucket]) return;
                this.GET_TASKS_BY_BUCKET(bucket);
            },
            emptyMessage(bucket) {
                switch (bucket) {
                    case 'today':  return 'אין משימות להיום';
                    case 'future': return 'אין משימות עתידיות';
                    case 'closed': return 'אין משימות שבוצעו';
                    default:       return 'אין משימות';
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    .home {
        padding-top: 70px;
    }
</style>
